import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

@connect(
  state => (state.wallet)
)
export default class FreePoints extends Component {

  static propTypes = {
    freePointsDisabled: PropTypes.bool.isRequired,
    votesLeftUntilFreePoint: PropTypes.number.isRequired
  }

  render() {

    const { freePointsDisabled, votesLeftUntilFreePoint, player, votesRequiredForFreePoint, gameType } = this.props

    if (freePointsDisabled) return null

    if (gameType == 1 || gameType == 2) {
      return <div className="pal-box pal-smallbox pull-right pal-freeopen">
        <h4>Iki nemokamo atvertimo liko:</h4>
        <img src="/dotnet/question/img/card3d.png" alt="" className="pull-left" />
        <div className="pull-left">
          <div className="pal-huge">{votesLeftUntilFreePoint}</div>
          <div className="pal-small">paspaudimų</div>
        </div>
        <div className="clearfix"></div>
        <p>{player.sex == 1 ? 'Ištarusi' : 'Ištaręs'} taip {votesRequiredForFreePoint} klubo narių gauk galimybę nemokamai atversti kortelę su tavimi norinčiųjų susitikti sąraše.</p>
      </div>;
    }

    return <div className="pal-box pal-smallbox pull-right pal-freeopen">
      <h4>Nemokamas atvertimas</h4>
      <div>
        <div className="pal-votes-left">
          <div className="pal-small">liko</div>
          <div className="pal-huge">{votesLeftUntilFreePoint}</div>
        </div>
        <p>Pasakyk TAIP {votesRequiredForFreePoint} vaikinams ir gauk nemokamą kortelės atvertimą.</p>
      </div>
    </div>;
  }
}
